import { useEffect } from 'react';

import { useLazyQuery } from '@apollo/client';

import CLASSROOM_MEMBERSHIP_QUERY from './graphql/ClassroomMembershipQuery.graphql';
import type {
  ClassroomMembershipQuery as ClassroomMembershipQueryResponse,
  ClassroomMembershipQueryVariables,
} from './graphql/types/ClassroomMembershipQuery';

const useMembershipData = (options?: { skipQuery?: boolean }) => {
  const [getMembershipData, { data, loading }] = useLazyQuery<
    ClassroomMembershipQueryResponse,
    ClassroomMembershipQueryVariables
  >(CLASSROOM_MEMBERSHIP_QUERY, {
    variables: {
      group: 'MEMBERSHIP_PRICING_LANDING_KEY',
      tag: 'PREMIUM_DUO',
    },
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentionally managed
  useEffect(() => {
    if (!options?.skipQuery) {
      getMembershipData();
    }
  }, [options?.skipQuery]);

  const currencySymbol = data?.membershipType?.prices?.currencySymbol;
  const price = data?.membershipType?.prices?.total;
  const monthlyPrice = data?.membershipType?.prices?.monthlyPrice;

  return {
    membership: data?.membershipType?.prices
      ? {
          price:
            currencySymbol && price ? `${currencySymbol}${price}` : undefined,
          monthlyPrice:
            currencySymbol && monthlyPrice
              ? `${currencySymbol}${monthlyPrice}`
              : undefined,
          checkoutUrl: data?.membershipType?.urlCheckout,
          discount: data?.membershipType?.discount,
        }
      : undefined,
    loading,
  };
};

export default useMembershipData;
